<h2 class="nordic-blue-900-text" [ngClass]="headingClasses">{{ titleTranslationKey | finLocalization }}</h2>

<div
  class="mr-small-t white-bg rounded-large border pr-small"
  *ngIf="headerContents$ | async as contents"
  data-test-header-contents
>
  <div *ngFor="let item of contents; let first = first; let isLast = last" [class.mr-small-t]="!first">
    <p>
      {{ item }}
    </p>
  </div>
</div>

<div class="bound-products pr-xsmall-t">
  <fcom-tabs
    [theme]="TabTheme.CLASSIC"
    [layoutType]="TabLayoutType.STRETCH"
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    [tabStyleOverrideClasses]="'pr-small'"
  >
    <div class="white-bg rounded-bottom-large border-bottom border-left border-right">
      <fcom-tab
        [title]="
          booking.locations[boundWithServices.departure.locationCode]?.cityName +
          ' - ' +
          booking.locations[boundWithServices.arrival.locationCode]?.cityName
        "
        *ngFor="let boundWithServices of servicesForBounds"
      >
        <div class="pr-small" *ngIf="boundWithServices.services.length === 0">
          <fcom-notification>{{ 'MMB.includedProducts.noServicesTitle' | finLocalization }}</fcom-notification>
        </div>
        <ng-container *ngFor="let service of boundWithServices.services; first as isFirstService">
          <div class="pr-small-b" [class.border-top]="!isFirstService">
            <fin-dapi-included-product-item
              [attr.data-test-category]="service.category"
              [category]="service.category"
              [buttonTranslationKey]="'MMB.includedProducts.' + service.category + '.title'"
              [additionalTitle]="
                showAdditionalTitle
                  ? ('purchase.review.ancillarySelection'
                    | finLocalization
                      : { amount: service.bounds[0]?.quantity, price: service.bounds[0]?.totalPrice | finPrice })
                  : ''
              "
              [passengers]="booking.passengers"
              [bound]="boundWithServices"
              [service]="service"
              [expandOpen]="!!service.upsell || expandOpen"
            >
              <div
                *ngIf="!!service.upsell && service.bounds[0]?.quantity === 0"
                class="nordic-blue-900-text font-body-1 flex flex--middle"
                data-test-not-included
              >
                <fcom-icon class="grey-500-text" name="close-delete"></fcom-icon>
                <div class="ps-xxsmall-l">{{ 'MMB.services.notIncluded' | finLocalization }}</div>
              </div>

              <fin-dapi-included-service
                [service]="service"
                [showAsPending]="showAsPending"
                [cartOrOrder$]="booking | finToObservable"
                [passengers$]="booking.passengers | finToObservable"
              ></fin-dapi-included-service>

              <fin-upsell-card
                *ngIf="service.upsell"
                [service]="service"
                (upsellClicked)="upsellClicked.emit($event)"
              ></fin-upsell-card>

              <fin-information-modal
                *ngIf="showInformationModal"
                [category]="service.category"
                [upsell]="(upsellInModal$ | async)?.[boundWithServices.id]?.[service.category] ?? false"
                (upsellClicked)="upsellClicked.emit($event)"
              ></fin-information-modal>

              <fcom-button
                class="block pr-small-t align-right flex--self-end"
                *ngIf="showModifyButtons"
                (click)="modifyClicked.emit(service.category)"
                [theme]="ButtonTheme.SECONDARY"
                [size]="ButtonSize.R_MEDIUM"
                [mode]="ButtonMode.FILL_MOBILE"
                [text]="'actions.modify' | finLocalization"
              ></fcom-button>
            </fin-dapi-included-product-item>
          </div>
        </ng-container>

        <div *ngIf="showTickets" class="pr-small-b" [class.border-top]="servicesToShow.length > 0">
          <fin-dapi-included-product-item
            data-test-category="tickets"
            category="tickets"
            buttonTranslationKey="MMB.includedProducts.tickets.title"
            additionalTitle=""
          >
            <fin-dapi-included-tickets
              [locations]="booking.locations"
              [bound]="boundWithServices"
              [useCabinClass]="useCabinClass"
            ></fin-dapi-included-tickets>
          </fin-dapi-included-product-item>
        </div>
      </fcom-tab>
    </div>
  </fcom-tabs>
</div>
